module.exports = __webpack_public_path__ + "img/indication.c41ca578.svg";